import React, { Component } from 'react'
import "./footer.css";
import { ReactComponent as Youtube } from "../assets/youtube.svg";
import { ReactComponent as Instgram } from "../assets/instgram.svg";

class Footer extends Component {
    // constructor(props) {
    //     super(props);
    // }
    // state = {  }
    render() {
        return (
            <footer>
                <div className='bar'>
                    <h1>Address</h1>
                    <div className='social'>
                        <div id='youtube'>
                            {/* <Youtube/> */}
                            <Youtube />
                            <Instgram />
                        </div>
                    </div>
                </div>
                <p>© 2022 Lord of All Church. All Rights Reserved</p>
            </footer>
        );
    }
}

export default Footer;